<template>
  <div class="form-area">
    <div class="flex row justify-content-center">
      <div v-if="device==='desktop'" class="desktop-wrapper">
        <div v-for="(user, idx) in userList" :key="idx">
          <div class="baggage-wrapper">
            <div class="user-caption">{{ $t('booking.passenger') + (idx+1) + ' ' + user.firstName + ' ' + user.lastName }}</div>
            <baggage-information-app
              :user="user"
              :priceInfo="priceInfo"
              @updateBaggage="updateBaggageInformation"
            />
          </div>
        </div>
      </div>
      <div v-else class="mobile-wrapper">
        <div v-for="(user, idx) in userList" :key="idx">
          <div class="username-wrapper" @click="setActiveUser(idx)">
            <div class="user-caption">{{ $t('booking.passenger') + (idx+1) + ' ' + user.firstName + ' ' + user.lastName }}</div>
            <div :class="['arrow-icon', idx === activeUserIndex ? 'icon-upward' : 'icon-downward']"></div>
          </div>
          <baggage-information-app
            :user="user"
            :priceInfo="priceInfo"
            @updateBaggage="updateBaggageInformation"
            v-if="idx === activeUserIndex"
          />
        </div>
      </div>
    </div>
    <div class="total-caption">{{ $t('booking.total-additions') }} {{ totalBaggagePrice }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
    BaggageInformationApp: () => import('@/components/booking/atoms/BaggageInformationApp'),
  },
  props: {
    userList: {
      type: Array,
      default: null,
    },
    priceInfo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      lang: 'GET_LANGUAGE',
      device: 'GET_DEVICE',
    }),
    totalBaggagePrice() {
      return `${this.baggagePrice}$`;
    },
  },
  data() {
    return {
      activeUserIndex: 0,
      baggagePrice: 0,
    }
  },
  watch: {
    lang: 'updateLabelWithLang',
  },
  created() {
    this.userList.forEach(user => {
      user.baggageInfo = {
        hasHandbag: true,
        hasTrolley: this.priceInfo.trolleyPrice === null,
        hasSuitcase: this.priceInfo.suitcasePrice === null,
        hasHandbagReturn: true,
        hasTrolleyReturn: this.priceInfo.trolleyReturnPrice === null,
        hasSuitcaseReturn: this.priceInfo.suitcaseReturnPrice === null,
      }
    });

    // set active user
    this.activeUserIndex = 0;
  },
  methods: {
    setActiveUser(index) {
      this.activeUserIndex = index;
    },
    updateBaggageInformation(info) {
      // update baggage information
      const user = this.userList.find(user => user.id === info.user.id && user.groupID === info.user.groupID);
      user.baggageInfo = info.baggageInfo;

      // calculate additional baggage cost
      let price = 0;
      this.userList.forEach(user => {
        const info = user.baggageInfo;
        const cost = info ?
          (info.hasTrolley ? +this.priceInfo.trolleyPrice : 0) +
          (info.hasSuitcase ? +this.priceInfo.suitcasePrice : 0) +
          (info.hasTrolleyReturn ? +this.priceInfo.trolleyReturnPrice : 0) +
          (info.hasSuitcaseReturn ? +this.priceInfo.suitcaseReturnPrice : 0)
          : 0;
        price += cost;
      })

      this.baggagePrice = price;

      this.$emit('updateBaggagePrice', price);
    },
  },
};
</script>

<style lang="less" scoped>
 .form-area{
    font-family: "ploni";

    .desktop-wrapper{
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      width: min-content;

      .baggage-wrapper{
        width: 299px;
        border-radius: 14px;
        border: solid 1px #d8e3f0;
        background: #ffffff;
        padding: 16px;
        margin: 16px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
      }
    }

    .mobile-wrapper{
      width: calc(100% - 16px);
      max-width: 480px;
      border-radius: 14px;
      border: solid 1px #d8e3f0;
      background: #ffffff;
      padding: 14px;
      margin: 12px auto;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
    }

    .user-caption{
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      margin-bottom: 12px;
      color: #0e436b;
    }

    .username-wrapper{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 4px 0;
      padding: 6px 4px;
      cursor: pointer;
      transition: color 0.18s ease;

      &:hover{
        color: #1c7ed6;
      }

      .user-caption{
        margin-bottom: 0;
        font-size: 15px;
        font-weight: 600;
      }

      .arrow-icon{
        width: 20px;
        height: 20px;
        opacity: 0.6;
      }
      .icon-downward{
        background: url("data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%228%22%20viewBox%3D%220%200%2014%208%22%20fill%3D%22none%22%20xmlns%3D%22http://www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M1%201L7%207L13%200.999999%22%20stroke%3D%22black%22%20stroke-width%3D%221.58358%22%20stroke-linecap%3D %22round %22 %20stroke-linejoin %3D %22round %22/%3E %3C/svg %3E") no-repeat center;
      }
      .icon-upward{
        background: url("data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%228%22%20viewBox%3D%220%200%2014%208%22%20fill%3D%22none%22%20xmlns%3D%22http://www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M1%207L7%201L13%207%22%20stroke%3D%22black%22%20stroke-width%3D%221.58358%22%20stroke-linecap%3D %22round %22 %20stroke-linejoin %3D %22round %22/%3E %3C/svg %3E") no-repeat center;
      }
    }

    .total-caption{
      display: inline-block;
      font-size: 18px;
      line-height: 1.4;
      font-weight: 700;
      text-align: center;
      margin: 16px auto 8px;
      padding: 8px 20px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f0fb 100%);
      border: 1px solid #cfe2ff;
      border-radius: 999px;
      color: #0e436b;
    }
  }

  @media (max-width: 479px) {

  }
</style>
